import script from "./FileImportModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileImportModal.vue?vue&type=script&setup=true&lang=ts"

import "./FileImportModal.vue?vue&type=style&index=0&id=5bf148ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bf148ae"]])

export default __exports__